import L from 'leaflet';
import PropTypes from 'prop-types';
import { useEffect } from 'react';

import useLeafletLayer from './useLeafletLayer';

// Style props given at top level apply at creation; later restyling goes through pathOptions
function LeafletPolyline(props) {
  const {
    positions,
    pathOptions,
    eventHandlers,
    ...styleOptions
  } = props;

  const polyline = useLeafletLayer(
    () => L.polyline(positions, { ...styleOptions, ...pathOptions }),
    eventHandlers,
  );

  useEffect(
    () => {
      if (polyline) polyline.setLatLngs(positions);
    },
    [polyline, positions],
  );

  useEffect(
    () => {
      if (polyline && pathOptions) polyline.setStyle(pathOptions);
    },
    [polyline, pathOptions],
  );

  return null;
}

LeafletPolyline.propTypes = {
  positions: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.number),
    PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number,
    }),
  ])).isRequired,
  pathOptions: PropTypes.shape({}),
  eventHandlers: PropTypes.shape({}),
};

export default LeafletPolyline;
